// extracted by mini-css-extract-plugin
export var closeButton = "_nn-1";
export var closeX = "_nn-3";
export var container = "_nn-0";
export var image = "_nn-2";